<template>
  <div>
    <wty-UserGroup :who="'service'"></wty-UserGroup>
  </div>
</template>
<script>
//import { getBasePermissionClassify, getBasePermissionList } from '@/api/service.js';
import wtyUserGroup from '@/components/wty-userGroup.vue';
export default {
  name: "userGroup",
  data() {
    return {

    }
  },
  components: { wtyUserGroup },
  async mounted() {
    /* const a = await getBasePermissionClassify();
    console.log("getBasePermissionList", a);
    const b = await getBasePermissionList();
    console.log("getBasePermissionList", b); */
  }
}
</script>

<style lang="less" scoped>

</style>